import React from 'react';
import { useWorldStore } from '../state/worldStore';
import { SPOR1_CAR } from '../worldRide';
import { useRideGate } from '../hooks/useRideGate';

// Spor1's Lotus — THE CITY'S OWN PARKED ELISE, not a planted prop.
//
// (History, 2026-08-02: a second Elise was mounted for the pickup and Khari
// caught it twice — first huge, then redundant: "there's already a lotus…
// no need to plant a second one." The city model ships with the parked car
// baked in, and CityModel already publishes its world position as the
// store's `landmark` — the fly-in has landed beside it since before this
// feature existed. So the game binds to THAT car.)
//
// This component is now only the BEACON: a warm pool of light on the native
// car while the ride step is open, so Lyra's "yellow Lotus, you can't miss
// it" stays literally true at night. RideOverlay gates the pickup prompt on
// proximity to the same spot.

export default function Spor1Lotus() {
  const entered = useWorldStore((s) => s.entered);
  const interior = useWorldStore((s) => s.interior);
  const ride = useWorldStore((s) => s.ride);
  const landmark = useWorldStore((s) => s.landmark);

  // The beacon is part of the story, so it waits for the story to start —
  // see useRideGate. It used to light for members the moment the ride quest
  // was available, which for a seeded artist is before Lyra has rung.
  const { rideOpen } = useRideGate();
  // ── THE LIGHT STAYS MOUNTED; ONLY ITS INTENSITY SWITCHES ──────────────────
  // How many lights a scene has is compiled INTO every lit shader. Mounting this
  // one when the ride opened — which is the moment right after Lyra's call, the
  // story's most important beat — changed that count and made three recompile
  // every material in the city on the spot: a visible hitch exactly when the
  // player is meant to be looking for the car. A dark light costs a few ALU ops;
  // a recompile costs seconds.
  // Indoors too: a SITED room keeps the city rendered around it, and dropping
  // the light there would recompile the city on the way in — the exact stall
  // this exists to avoid. It simply goes dark.
  const on = entered && !interior && !ride && rideOpen;

  const [x, , z] = landmark || [SPOR1_CAR.pos[0], 0, SPOR1_CAR.pos[1]];

  return (
    <group position={[x, 0, z]}>
      <pointLight position={[0, 1.2, 0]} intensity={on ? 2.2 : 0} distance={7} color="#ffd24a" />
    </group>
  );
}
